import { render, staticRenderFns } from "./role-assign-b2c.vue?vue&type=template&id=76d8b980&"
import script from "./role-assign-b2c.vue?vue&type=script&lang=js&"
export * from "./role-assign-b2c.vue?vue&type=script&lang=js&"
import style0 from "./role-assign-b2c.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports